import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReportListState } from "./model";
import { IPayloadSetError } from "../../../store/Interfaces";
import { ConfigReport } from "../../../utils/types/ConfigReport";
import { Signal } from "../../../utils/interfaces/store/IStore";

const initialState: ReportListState = {
  configReports: Signal.default([]),
  configReportsSelected: Signal.default([]),
};

export const ReportListSlice = createSlice({
  name: "reportList",
  initialState,
  reducers: {
    clean: (_, action: PayloadAction<undefined>) => {
      return {
        ...initialState,
        action: { ...action } as any,
      } as ReportListState;
    },
    getConfigReports: (state, action: PayloadAction<undefined>) => {
      return {
        ...state,
        action: { ...action } as any,
        configReports: Signal.loading(),
      } as ReportListState;
    },
    getConfigReportsSuccess: (state, action: PayloadAction<ConfigReport[]>) => {
      return {
        ...state,
        action: { ...action } as any,
        configReports: Signal.success(action.payload),
      } as ReportListState;
    },
    getConfigReportsError: (state, action: PayloadAction<IPayloadSetError>) => {
      return {
        ...state,
        action: { ...action } as any,
        configReports: Signal.error(
          action.payload.error,
          action.payload.shorterror
        ),
      } as ReportListState;
    },
    getConfigReportsSelected: (state, action: PayloadAction<undefined>) => {
      return {
        ...state,
        action: { ...action } as any,
        configReportsSelected: Signal.loading(),
      } as ReportListState;
    },
    getConfigReportsSelectedSuccess: (
      state,
      action: PayloadAction<ConfigReport[]>
    ) => {
      return {
        ...state,
        action: { ...action } as any,
        configReportsSelected: Signal.success(action.payload),
      } as ReportListState;
    },
    getConfigReportsSelectedError: (
      state,
      action: PayloadAction<IPayloadSetError>
    ) => {
      return {
        ...state,
        action: { ...action } as any,
        configReportsSelected: Signal.error(
          action.payload.error,
          action.payload.shorterror
        ),
      } as ReportListState;
    },
  },
});
